import { Box, Button, TableCell, TableRow } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import React from 'react';

const LessonItem = ({ lesson, handleEditClick, handleDeleteClick }) => {
	return (
		<TableRow>
			<TableCell>{lesson.title}</TableCell>
			<TableCell>{lesson.duration}</TableCell>
			<TableCell>
				<Button startIcon={<Edit />} onClick={() => handleEditClick(lesson.id)}>
					Edit
				</Button>
				<Button
					startIcon={<Delete />}
					onClick={() => handleDeleteClick(lesson)}
				>
					Delete
				</Button>
			</TableCell>
		</TableRow>
	);
};

export default LessonItem;
